import React from "react";
import { LeasedFeeSaleProps } from "./utils/types";
import { SaleTable } from "./utils/SaleTable";

export const LeasedFeeSale: React.FC<LeasedFeeSaleProps> = ({ data }) => {
    const saleData =
        data.appealDetails?.appealApproachCalculationData.exportAppealsPackage?.valueBasedSale
            ?.currentYear;

    return <SaleTable saleData={saleData} type="leasedFee" />;
};
